import { BriefingRecurrenceFrequencyApiEnum } from '../../../api/briefings/enum/briefing-recurrence-frequency-api.enum';

export enum BriefingRecurrenceFrequencyEnum {
    daily = 'DAILY',
    weekly = 'WEEKLY',
    monthly = 'MONTHLY',
    quarterly = 'QUARTERLY'
}

// No mapping from API to frontend due to the complexity of rules and trying to do this in a .map function

// The frontend "weekly" uses the backend "daily", backend only supports daily and weekly
export const briefingFrequencyTypeMapToApi = new Map<BriefingRecurrenceFrequencyEnum, BriefingRecurrenceFrequencyApiEnum>([
    [BriefingRecurrenceFrequencyEnum.daily, BriefingRecurrenceFrequencyApiEnum.daily],
    [BriefingRecurrenceFrequencyEnum.weekly, BriefingRecurrenceFrequencyApiEnum.daily],
    [BriefingRecurrenceFrequencyEnum.monthly, BriefingRecurrenceFrequencyApiEnum.monthly],
    // months/days are carried in monthDayPairs
    [BriefingRecurrenceFrequencyEnum.quarterly, BriefingRecurrenceFrequencyApiEnum.quarterly]
]);
